import loadable from '@loadable/component';

export const OrgDashboardEditEventPageLoadable = loadable(
  () => import('./OrgDashboardEditEventPage'),
  {
    resolveComponent: (module) => module.OrgDashboardEditEventPage,
  },
);
